// Higher precision means better data.
export default {
	default: {
		identifier: 'defaultResistance'
		, precision: 1
	}
	, class: {
		identifier: 'classResistance'
		, precision: 5
	}
	, import: {
		identifier: 'importResistance'
		, precision: 10
	}
};


// WEBPACK FOOTER //
// ./js/models/resistances/resistanceTypes.js